var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_86041",
    "data-name": "Group 86041",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.967,
    height: 12.967,
    viewBox: "0 0 12.967 12.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3762",
    "data-name": "Rectangle 3762",
    width: 12.967,
    height: 12.967,
    fill: "#707070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_86040",
    "data-name": "Group 86040",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47477",
    "data-name": "Path 47477",
    d: "M6.485,0A6.484,6.484,0,1,1,0,6.486,6.507,6.507,0,0,1,6.485,0m0,12.322A5.84,5.84,0,1,0,.643,6.488a5.862,5.862,0,0,0,5.846,5.834",
    transform: "translate(0 0)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47478",
    "data-name": "Path 47478",
    d: "M51.3,89.315a5.291,5.291,0,0,1-3.122-1.07,7.134,7.134,0,0,1-2.909-3.885,5.223,5.223,0,0,1-.186-1.343,1.207,1.207,0,0,1,1.066-1.328,2.205,2.205,0,0,1,.423-.052.7.7,0,0,1,.681.4,3.642,3.642,0,0,1,.455,1.444,1.226,1.226,0,0,1-.383,1.072.391.391,0,0,0-.111.545,4.392,4.392,0,0,0,2.179,2.139.4.4,0,0,0,.491-.062,1.37,1.37,0,0,1,1.4-.371,6.048,6.048,0,0,1,1,.342.721.721,0,0,1,.453.651,1.889,1.889,0,0,1-.21,1.044.864.864,0,0,1-.757.474c-.156.011-.313,0-.469,0",
    transform: "translate(-43.24 -78.301)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47479",
    "data-name": "Path 47479",
    d: "M142.734,57.288c0,.075,0,.15,0,.224a.331.331,0,1,1-.662,0,4.087,4.087,0,0,0-3.935-4.057c-.3-.015-.442-.1-.471-.289a.334.334,0,0,1,.373-.394,4.535,4.535,0,0,1,2.569.784,4.69,4.69,0,0,1,2.127,3.73",
    transform: "translate(-132.038 -50.618)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47480",
    "data-name": "Path 47480",
    d: "M134.382,86.273a3.516,3.516,0,0,1,3.3,3.429c.009.267-.116.415-.333.418s-.341-.141-.351-.406a2.791,2.791,0,0,0-1.367-2.361,2.763,2.763,0,0,0-1.406-.419c-.262-.01-.42-.138-.414-.343s.18-.342.45-.328c.041,0,.081.007.122.01",
    transform: "translate(-128.345 -82.738)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47481",
    "data-name": "Path 47481",
    d: "M132.5,122.053a.331.331,0,0,1-.236.4.3.3,0,0,1-.383-.153.951.951,0,0,1-.064-.315,1.572,1.572,0,0,0-1.031-1.37,2.049,2.049,0,0,0-.553-.11c-.221-.024-.381-.155-.383-.344a.365.365,0,0,1,.4-.346,2.327,2.327,0,0,1,2.251,2.24",
    transform: "translate(-124.545 -114.919)",
    fill: "#707070"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9cf064b84c2e7d4e015387efd8f954e8.svg";
export { ForwardRef as ReactComponent };